import { configureStore, createSlice } from '@reduxjs/toolkit';
import uploadAPI from 'src/services/upload-query';
import announcementAPI from 'src/services/announcement-query';
import syllabusAPI from 'src/services/syllabus-query';
import mcqAPI from 'src/services/mcq-query';
import staffAPI from 'src/services/staff-query';
import profileAPI from 'src/services/profile-query';
import publicAPI from 'src/services/public-api';

const homeSlice = createSlice({
  name: 'home',
  initialState: {},
  reducers: {},
});

export const store = configureStore({
  reducer: {
    home: homeSlice.reducer,
    [uploadAPI.reducerPath]: uploadAPI.reducer,
    [announcementAPI.reducerPath]: announcementAPI.reducer,
    [syllabusAPI.reducerPath]: syllabusAPI.reducer,
    [mcqAPI.reducerPath]: mcqAPI.reducer,
    [staffAPI.reducerPath]: staffAPI.reducer,
    [profileAPI.reducerPath]: profileAPI.reducer,
    [publicAPI.reducerPath]: publicAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(uploadAPI.middleware)
      .concat(announcementAPI.middleware)
      .concat(syllabusAPI.middleware)
      .concat(mcqAPI.middleware)
      .concat(staffAPI.middleware)
      .concat(profileAPI.middleware)
      .concat(publicAPI.middleware)
});

export const homeActions = homeSlice.actions;
